import {Button, Text} from "@wakelet/ui-kit";
import {PageWithoutFooter, requireSession} from "../Page";
import {useEffect, useState} from "react";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {signInWithCustomToken} from "../../firebase";
import {useNavigate, useParams} from "react-router";
import {Navigate} from "react-router-dom";
import {FullPageSpinner} from "../../components/loading/Spinner";
import {isUnsupportedProvider} from "./provider-login";
import {WebErrorType} from "../../domain/web-errors";
import {useAuth} from "../../components/auth/AuthContext";
import {AccountSubdomainStore} from "../../components/auth/subdomain";

export const ProviderPostAuthPage = () => {
  const {user} = useAuth();
  const navigate = useNavigate();
  const params = useParams();
  const provider = params.provider || "";
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code") || "";
  const scope = searchParams.get("scope");
  const isDev = searchParams.get("dev");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  if (isUnsupportedProvider(provider)) {
    return <Navigate to="/error"/>
  }

  if (!code) {
    return <Navigate to="/error"/>
  }

  useEffect(() => {
    if (isDev) {
      return;
    }
    doLogin().
    then( () => {return}).
    catch(err => {
      console.error("error in provider post auth login", err);
      navigate("/error");
    })
  }, []);

  useEffect( () => {
    if (isAuthenticated && user) {
      navigate("/authenticated");
    }
  }, [isAuthenticated, user]);


  const doLogin = async () => {
    try {
      AccountSubdomainStore.clear();
      const resp = await AccountsAPI.providerLogin(provider, code);
      await signInWithCustomToken(resp.customToken);
      if (resp.subdomain) {
        AccountSubdomainStore.set(resp.subdomain)
      }
      setIsAuthenticated(true);
    } catch (err: any) {
      console.error("error with provider login", err)
      let qp = "";
      if (err?.body?.reason === "student_signup_prohibited") {
        qp = `?error=${WebErrorType.StudentSignupError}`;
      }
      navigate(`/error${qp}`);
    }
  }

  let pageContent = <FullPageSpinner />
  if (isDev) {
    pageContent = <PageWithoutFooter>
      <Text.Heading level={1}>clever post auth</Text.Heading>
      <Text.Paragraph>provider: {provider}</Text.Paragraph>
      <Text.Paragraph>code: {code}</Text.Paragraph>
      <Text.Paragraph>scope: {scope}</Text.Paragraph>
      <Button onClick={doLogin}>
        <Button.Label text="Login"/>
      </Button>
    </PageWithoutFooter>
  }

  return (
      requireSession(pageContent)
  )
};
